module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e95dbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-qrcode-component/src/QRCode.vue
// module id = 1432
// module chunks = 5